








import Vue from "vue";

interface Conferencista {
  img: string;
  title: string;
}

export default Vue.extend({
  data() {
    const conferencistas: Conferencista[] = [
      {
        img: "/images/conferencistas/1.png",
        title: "John Atkinson",
      },
      {
        img: "/images/conferencistas/2.png",
        title:
          "Ginna Leyton",
      },
      {
        img: "/images/conferencistas/3.png",
        title: "Andres Calderon",
      },
      {
        img: "/images/conferencistas/4.png",
        title: "Patricia Paderewski",
      },
      {
        img: "/images/conferencistas/5.png",
        title: "Francisco Gutierrez",
      },
      {
        img: "/images/conferencistas/6.png",
        title: "Hernán Zuluaga",
      },
      /*{
        img: "/images/conferencistas/7.png",
        title: "Luis Fernando Zambrano",
      },*/
    ];
    return {
      conferencistas,
    };
  },
});
